<template>
  <div class="pay-center-coin-exchange"
       :class="{ 'highlight': highlight }"
  >
    <span>{{ coin }}</span>
    <ym-img class="icon"
            :src="require('@/assets/img/pay_center/coin_icon.png')"
    />
  </div>
</template>

<script>
  export default {
    name: 'PayCenterCoinExchange',
    props: {
      coin: {
        type: Number,
        required: true,
      },
      highlight: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {};
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .pay-center-coin-exchange {
    display: flex;
    align-items: center;
    color: @color-text-base;
    font-size: @font-size-base;
    line-height: 1;
    .icon {
      width: 24px;
      height: 24px;
      margin-left: 6px;
    }
    &.highlight {
      color: @color-highlight;
    }
  }

</style>
